import {axiosBase} from "./axiosBase";
import {LoginModel} from "../types/LoginModel";
const LOGIN_URL = "login/login";

export const loginService = {
    login : (data : LoginModel) => {
        return axiosBase.post(LOGIN_URL,data);
    }
}